package com.ijoin.i18n

/**
 * Spanish strings implementation
 */
object SpanishStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "¡Haz clic!"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "¡Hola, $platformName!"
    override val language = "Idioma"
    override val english = "Inglés"
    override val russian = "Ruso"
    override val changeLanguage = "Cambiar idioma"
    override val ok = "Aceptar"
    override val cancel = "Cancelar"
    override val save = "Guardar"
    override val delete = "Eliminar"
    override val edit = "Editar"
    override val close = "Cerrar"
    override val retry = "Reintentar"
    override val share = "Compartir"
    override val unknownErrorMessage = "Algo salió mal. Por favor, inténtelo de nuevo."
    override val missingEventDateError = "Falta la fecha del evento."
    override val slotSelectionRequired = "Seleccione al menos un horario."
    override val userContextMissingError = "No se pudo identificar al usuario actual."
    override val cancelSlotsSelectionRequired = "Seleccione al menos un horario para cancelar."
    override val cancelDaySelectionRequired = "Seleccione un día para cancelar."
    override val restoreSlotsSelectionRequired = "Seleccione al menos un horario para restaurar."
    override val restoreDaySelectionRequired = "Seleccione un día para restaurar."
    override val cancelSlotsFailed = "No se pudieron cancelar los horarios seleccionados."
    override val cancelDayFailed = "No se pudo cancelar el día seleccionado."
    override val restoreSlotsFailed = "No se pudieron restaurar los horarios seleccionados."
    override val restoreDayFailed = "No se pudo restaurar el día seleccionado."
    override val cancelEventFailed = "No se pudo cancelar el evento."
    override val restoreEventFailed = "No se pudo restaurar el evento."
    override val selectedDateUnavailableError = "La fecha seleccionada no está disponible."
    override val selectedDateInPastError = "La fecha seleccionada ya pasó."
    override val notSelected = "No seleccionado"
    override fun atTime(time: String) = "a las $time"
    override val enableNotificationsTitle = "Mantente informado"
    override val enableNotificationsBody = "Activa las notificaciones del navegador para recibir actualizaciones sobre nuevos eventos y actividad del chat."
    override val allowNotificationsAction = "Permitir notificaciones"
    override val notNowAction = "Ahora no"
    override val searchPlaceholder = "Buscar eventos, organizadores, lugares..."
    override val myTickets = "Mis entradas"
    override val tapToViewTicket = "Toca para ver la entrada"
    override val favoriteEvents = "Favoritos"
    override val eventsYouSaved = "Eventos que guardaste"
    override val recommendedForYou = "Recomendados para ti"
    override val curatedEvents = "Eventos seleccionados según tus intereses"
    override val recommendations = "Recomendaciones"
    override val upcomingEvents = "Próximos eventos"
    override val searchResults = "Resultados de búsqueda"
    override val noResults = "No se encontraron resultados"
    override val noAvailableEvents = "No hay eventos disponibles"
    override val createEvent = "Crear evento"
    override val menu = "Menú"
    override val home = "Inicio"
    override val explore = "Explorar"
    override val tickets = "Entradas"
    override val profile = "Perfil"
    override val upcomingPaidTicketsTitle = "Próximas entradas pagadas"
    override val otherTicketsTitle = "Otras entradas"
    override val offlineTicketsNotice = "Mostrando entradas guardadas. Alguna información puede estar desactualizada."
    override val ticketsEmptyMessage = "Aún no tienes entradas."
    override val ticketDetailsTitle = "Detalles de la entrada"
    override val ticketNumberLabel = "Número de entrada"
    override val ticketStatusActive = "Activa"
    override val ticketStatusCancelled = "Cancelada"
    override val ticketStatusRefunded = "Reembolsada"
    override val ticketStatusUsed = "Usada"
    override val ticketHolderLabel = "Titular"
    override val cancelTicketAction = "Cancelar entrada"
    override val ticketCancellationConfirmTitle = "¿Cancelar entrada?"
    override val ticketCancellationConfirmMessage = "Esto liberará tu lugar para otro asistente."
    override val ticketCancellationSuccess = "Entrada cancelada"
    override val ticketCancellationFailure = "No se pudo cancelar la entrada"
    override val ticketLoadError = "No se pudo cargar la entrada"
    override val refresh = "Actualizar"
    override val settings = "Configuración"
    override val createEventTitle = "Crear evento"
    override val eventTitle = "Título del evento"
    override val eventTitlePlaceholder = "Ingresa el nombre del evento"
    override val eventDescription = "Descripción"
    override val eventDescriptionPlaceholder = "Describe tu evento..."
    override val aiGenerateDescription = "IA: generar descripción"
    override val aiFormatDescription = "IA: estructurar y finalizar la descripción"
    override val addMedia = "Agregar foto/video"
    override val mediaChooseFile = "Elegir archivo"
    override val location = "Ubicación"
    override val onlineEvent = "Evento en línea"
    override val onlineLink = "Enlace en línea"
    override val onlineLinkPlaceholder = "https://ejemplo.com/reunion"
    override val onlineLinkNotice = "El enlace estará disponible después del pago"
    override val placeName = "Nombre del lugar"
    override val address = "Dirección"
    override val ticketPrice = "Precio de la entrada"
    override val ticketPricePlaceholder = "25.00"
    override val dateAndTime = "Fecha y hora"
    override val recurringEvent = "Evento recurrente"
    override val recurrenceType = "Tipo de recurrencia"
    override val daysOfWeek = "Días de la semana"
    override val daysOfMonth = "Días del mes"
    override val selectDaysOfWeek = "Seleccionar días de la semana"
    override val selectDaysOfMonth = "Seleccionar días del mes"
    override val time = "Hora (HH:MM)"
    override val hiddenInfo = "Información oculta"
    override val hiddenInfoDescription = "Estará disponible para los usuarios después de comprar la entrada"
    override val hiddenInfoPlaceholder = "Información visible solo después del pago..."
    override val enableGroupChatLabel = "Crear chat grupal"
    override val enableGroupChatDescription = "Todos los que reserven o compren una entrada se unirán a un chat compartido."
    override val groupChatLabel = "Chat grupal"
    override val groupChatSubtitle = "Chat para todos los participantes"
    override val carpoolSettings = "Configuración de viaje compartido"
    override val enableCarpool = "Habilitar viaje compartido"
    override val contactInfoSettings = "Configuración de información de contacto"
    override val requireContactInfo = "Recopilar información de contacto"
    override val requireContactInfoDescription = "Requerir que los clientes proporcionen teléfono e información adicional al reservar"
    override val freeCarpool = "Viaje compartido gratuito"
    override val carpoolPaymentPerPerson = "Pago por pasajero"
    override fun carpoolPaymentLabel(symbol: String) = "Pago por persona ($symbol)"
    override val carpoolPaymentPlaceholder = "10.00"
    override val carpoolDescription = "Los usuarios pueden indicar que tienen un coche y especificar cuántos pasajeros pueden transportar"
    override val carpoolPaymentHint = "Establece cuánto deben pagar los pasajeros por el viaje"
    override val selectDate = "Seleccionar fecha"
    override val back = "Atrás"
    override val create = "Crear"
    override val currency = "Moneda"
    override val selectCurrency = "Seleccionar moneda"
    override val category = "Categoría"
    override val selectCategory = "Seleccionar categoría"
    override val tags = "Etiquetas"
    override val addTag = "Agregar etiqueta"
    override val maxCapacity = "Capacidad máxima"
    override val maxCapacityPlaceholder = "50"
    override val duration = "Duración"
    override val durationMinutes = "Duración (minutos)"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "$weeks semana${if (weeks > 1) "s" else ""} $remainingDays día${if (remainingDays > 1) "s" else ""}"
                else "$weeks semana${if (weeks > 1) "s" else ""}"
            }
            days > 0 -> {
                if (hours > 0) "$days día${if (days > 1) "s" else ""} $hours h"
                else "$days día${if (days > 1) "s" else ""}"
            }
            hours > 0 -> {
                if (mins > 0) "$hours h $mins min"
                else "$hours h"
            }
            else -> "$mins min"
        }
    }
    override val locationCountry = "País"
    override val selectOnMap = "Seleccionar en el mapa"
    override val locationSearchPlaceholder = "Ingresa dirección o nombre del lugar"
    override val onlineLinkHidden = "El enlace será visible solo después del pago"
    override val timeZone = "Zona horaria"
    override fun timeZoneValue(timeZoneId: String) = "Zona horaria: $timeZoneId"
    override val selectTimeZone = "Seleccionar zona horaria"
    override val localTimeZone = "Zona horaria local"
    override val mediaFilesAdded = "Archivos agregados"
    override val free = "Gratis"
    override val priceForFreeEvent = "0 - para evento gratuito"
    override val additionalOptions = "Opciones adicionales"
    override val ageRestriction = "Restricción de edad"
    override val languageEvent = "Idioma del evento"
    override val contactInfo = "Información de contacto"
    override val website = "Sitio web"
    override val phone = "Teléfono"
    override val email = "Correo electrónico"
    override val comment = "Comentario"
    override val phoneRequired = "El teléfono es obligatorio"
    override val city = "Ciudad"
    override val search = "Buscar"
    override val year = "Año"
    override val month = "Mes"
    override val day = "Día"
    override fun weekdayShortName(index: Int) = listOf("Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom")[index % 7]
    override fun weekdayName(index: Int) = listOf("Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo")[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = listOf(
        "de enero", "de febrero", "de marzo", "de abril", "de mayo", "de junio",
        "de julio", "de agosto", "de septiembre", "de octubre", "de noviembre", "de diciembre"
    )[(month - 1).mod(12)]
    override val createEventWizard = "Crear evento"
    override val step = "Paso"
    override val of = "de"
    override val next = "Siguiente"
    override val previous = "Anterior"
    override val saveDraft = "Guardar borrador"
    override val editEvent = "Editar evento"
    override val step1BasicInfo = "Información básica"
    override val step2Schedule = "Horario"
    override val scheduleTypeLabel = "Tipo de horario"
    override val scheduleOneTimeDescription = "Evento único en una fecha elegida"
    override val scheduleWeeklyDescription = "Se repite en los días seleccionados"
    override val scheduleSlotDescription = "Calendario de horarios reservables"
    override val scheduleOneTimeSetup = "Configuración de evento único"
    override val schedulePreviewTitle = "Vista previa"
    override fun schedulePreviewDate(date: String) = "Fecha: $date"
    override fun schedulePreviewTime(start: String, end: String) = "Hora: $start - $end"
    override val step3Location = "Ubicación"
    override val eventSetupTitle = "Configuración del evento"
    override val eventTypeLabel = "Tipo de evento"
    override val oneTimeEvent = "Evento único"
    override val eventSeries = "Serie de eventos"
    override val weekly = "Semanal"
    override val monthly = "Mensual"
    override val slotBooking = "Reserva de horarios"
    override val slotLabel = "Horario"
    override val slotsLabel = "Horarios"
    override val selectDayOfWeek = "Seleccionar día de la semana"
    override val selectDayOfMonth = "Seleccionar día del mes"
    override val availableTimeRange = "Rango de tiempo disponible"
    override val startTime = "Hora de inicio"
    override val endTime = "Hora de fin"
    override val endDateLabel = "Fecha de fin (opcional)"
    override val invalidEndDate = "La fecha de fin debe ser igual o posterior a la fecha de inicio"
    override val invalidEndTime = "La hora de fin debe ser posterior a la hora de inicio"
    override val eventDateMustBeFuture = "La fecha del evento debe ser en el futuro"
    override val eventTimeMustBeFuture = "La hora del evento debe ser posterior a la hora actual"
    override val slotSettings = "Configuración de horarios"
    override val minSlots = "Mín. horarios"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "Duración (min)"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "Horas disponibles para cada día"
    override val driverCompensation = "Compensación del conductor"
    override val fixedAmountPerPassenger = "Cantidad fija por pasajero"
    override val coordinateRide = "Coordinar viaje"
    override val participantsWithCar = "Participantes con coche"
    override val needRide = "Necesito transporte"
    override val draft = "Borrador"
    override val saved = "Guardado"
    override val eventSaveErrorTitle = "No se pudo guardar el evento"
    override val eventSaveErrorMessage = "Algo salió mal al guardar tu evento. Por favor, inténtalo de nuevo."
    override val deleteEventTitle = "¿Eliminar evento?"
    override val deleteEventMessage = "Esta acción no se puede deshacer. ¿Deseas continuar?"
    override val eventDeletedMessage = "Evento eliminado"
    override val organizerLabel = "Organizador"
    override val online = "En línea"
    override val offline = "Presencial"
    override val eventDetailsTitle = "Detalles del evento"
    override val addToFavorites = "Agregar a favoritos"
    override val removeFromFavorites = "Quitar de favoritos"
    override val ticketTierStandard = "Estándar"
    override fun ticketsAvailable(count: Int) = "$count entradas disponibles"
    override val viewTicket = "Ver entrada"
    override val bookingRequestFailed = "No se pudo reservar la entrada"
    override val contactSendFailed = "No se pudo enviar la información de contacto"
    override val unexpectedReservation = "Reserva inesperada para evento gratuito"
    override val sampleReviewerName = "Ana García"
    override val sampleReviewTimeAgo = "hace 2 días"
    override val selectVisitDate = "Seleccionar fecha de visita"
    override fun availableDaysLabel(days: String) = "Días disponibles: $days"
    override val previousMonth = "Mes anterior"
    override val nextMonth = "Mes siguiente"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "Seleccionaste: $date" else "Seleccionaste: $date a las $time"
    override fun eventImageContentDescription(title: String, index: Int) = "$title - Imagen $index"
    override val dateTbd = "Por determinar"
    override val recurringWeeklyDescription = "Este evento se realiza cada semana en los días seleccionados."
    override val recurringMonthlyDescription = "Este evento se realiza cada mes en los días seleccionados."
    override val userCardTitle = "Perfil del organizador"
    override val followAction = "Seguir"
    override val followingAction = "Siguiendo"
    override val followersCountLabel = "Seguidores"
    override val followingCountLabel = "Siguiendo"
    override val eventsCountLabel = "Eventos"
    override val organizerEventsTitle = "Próximos eventos"
    override val archiveSectionTitle = "Archivo"
    override val aboutOrganizerTitle = "Sobre el organizador"
    override val userEventsEmpty = "Este organizador aún no tiene eventos próximos."
    override val userArchiveEmpty = "No hay eventos archivados."
    override val addShortcutTitle = "¿Agregar acceso directo?"
    override fun addShortcutMessage(displayName: String) =
        "¿Agregar $displayName a tu pantalla de inicio para acceder rápidamente a sus eventos?"
    override val addShortcutConfirm = "Agregar acceso directo"
    override val addShortcutDismiss = "Ahora no"
    override val dateLabel = "Fecha"
    override val participants = "Participantes"
    override val spotsLeft = "lugares disponibles"
    override val ticketQuantityLabel = "Número de entradas"
    override val increaseQuantity = "Aumentar cantidad"
    override val decreaseQuantity = "Disminuir cantidad"
    override val costLabel = "Costo de participación"
    override val serviceFee = "Tarifa de servicio"
    override val totalAmount = "Total"
    override fun serviceFeePercent(percent: Int) = "Tarifa de servicio ($percent%)"
    override val dressCode = "Código de vestimenta"
    override val dressCodePlaceholder = "Formal"
    override val description = "Descripción"
    override val reviews = "Reseñas"
    override val allReviews = "Todas las reseñas"
    override val contactOrganizer = "Contactar organizador"
    override val slotBookingsTitle = "Reservas de horarios"
    override val slotBookingsEmptyMessage = "Aún no hay horarios reservados."
    override val showAllBookings = "Todas"
    override val showToday = "Hoy"
    override val showThisMonth = "Este mes"
    override val showSelectedDate = "Fecha seleccionada"
    override val noBookingsForSelectedDate = "No hay reservas para esta fecha."
    override val noTicketsForSelectedDate = "No hay entradas para esta fecha."
    override fun totalCount(count: Int) = "Total: $count"
    override val cancelEventAction = "Cancelar evento"
    override val cancelEventDescription = "Detener la venta de entradas y marcar el evento como cancelado."
    override val organizerActionsTitle = "Herramientas del organizador"
    override val eventAlreadyCancelledNotice = "El evento ya está cancelado."
    override val eventCancelledTitle = "Evento cancelado"
    override val eventCancelledSubtitle = "El organizador canceló este evento. Ya no es posible reservar."
    override val cancellationReasonLabel = "Motivo de cancelación"
    override val cancellationReasonPlaceholder = "Describe por qué estás cancelando"
    override val cancellationReasonRequired = "Por favor proporciona un motivo breve."
    override val cancelSelectedSlotsAction = "Cancelar horarios seleccionados"
    override val cancelSelectedSlotsDescription = "Los asistentes ya no podrán reservar los horarios seleccionados."
    override val cancelSlotDayAction = "Cancelar día seleccionado"
    override val cancelSlotDayDescription = "Todos los horarios del día seleccionado serán bloqueados."
    override val selectedSlotsLabel = "Horarios seleccionados"
    override val selectedDayLabel = "Día seleccionado"
    override val restoreEventAction = "Restaurar evento"
    override val restoreEventDescription = "Reabrir el evento después de una cancelación."
    override val restoreSelectedSlotsAction = "Restaurar horarios seleccionados"
    override val restoreSelectedSlotsDescription = "Permitir que los asistentes reserven los horarios seleccionados nuevamente."
    override val restoreSlotDayAction = "Restaurar día seleccionado"
    override val restoreSlotDayDescription = "Reabrir todos los horarios del día seleccionado."
    override val bookingStatusPending = "Pendiente"
    override val bookingStatusConfirmed = "Confirmada"
    override val bookingStatusCancelled = "Cancelada"
    override val bookingStatusCompleted = "Reservada"
    override val bookingStatusNoShow = "No presentado"
    override val viewDetails = "Ver detalles"
    override val hideDetails = "Ocultar detalles"
    override val openChat = "Abrir chat"
    override val clientNotesLabel = "Comentario del cliente"
    override val bookingDetailsTitle = "Detalles de la reserva"
    override val slotBookedByLabel = "Reservado por"
    override val slotAvailableLabel = "Disponible"
    override val statusLabel = "Estado"
    override val connectTitle = "Pagos directos"
    override val connectStatusActive = "Activo"
    override val connectStatusPending = "Pendiente"
    override val connectStatusPlatform = "Plataforma"
    override val connectStatusUnderReview = "En revisión"
    override val connectStatusSetupNeeded = "Configuración requerida"
    override val connectEnableDirectAction = "Habilitar pagos directos"
    override val connectContinueOnboarding = "Continuar configuración"
    override val connectOpenDashboard = "Abrir panel de Stripe"
    override val connectSwitchToPlatform = "Cambiar a pagos de plataforma"
    override val connectPlatformFeeLabel = "Comisión de la plataforma"
    override val connectDirectPaymentsEnabled = "Pagos directos habilitados"
    override val connectSwitchedToPlatform = "Cambiado a pagos de plataforma"
    override val connectOnboardingDescription = "Configura tu cuenta de Stripe para recibir pagos directamente"
    override val connectActiveDescription = "Los pagos van directamente a tu cuenta de Stripe"
    override val connectPlatformDescription = "Los pagos se procesan a través de la plataforma"
    override val connectUnderReviewDescription = "Tu cuenta está siendo revisada por Stripe"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "Facturación"
    override val currentBalanceLabel = "Saldo actual"
    override val openBillingAction = "Facturación y pagos"
    override val withdrawFundsAction = "Retirar fondos"
    override val pendingPayoutsLabel = "Pagos pendientes"
    override val withdrawnTotalLabel = "Retirado"
    override val billingFilterWeek = "7 días"
    override val billingFilterMonth = "30 días"
    override val billingFilterQuarter = "90 días"
    override val grossSalesLabel = "Ventas brutas"
    override val feesLabel = "Tarifas"
    override val netRevenueLabel = "Ingresos netos"
    override val payoutRequestsTitle = "Solicitudes de retiro"
    override val payoutRequestsEmpty = "Aún no hay solicitudes de retiro"
    override val payoutStatusPending = "Pendiente"
    override val payoutStatusProcessing = "Procesando"
    override val payoutStatusPaid = "Pagado"
    override val payoutStatusRejected = "Rechazado"
    override val requisitesTitle = "Detalles de pago"
    override val requisitesAccountLabel = "Número de cuenta"
    override val requisitesInnLabel = "INN"
    override val requisitesKppLabel = "KPP"
    override val requisitesBikLabel = "BIC"
    override val bankLabel = "Banco"
    override val soldTicketsTitle = "Entradas vendidas"
    override val soldTicketsEmpty = "No hay ventas de entradas en este período"
    override val withdrawConfirmTitle = "¿Retirar fondos?"
    override fun withdrawConfirmMessage(amount: String) = "Estás a punto de solicitar un pago de $amount."
    override val billingWithdrawSuccess = "Solicitud de retiro enviada"
    override val billingWithdrawFailed = "No se pudo enviar la solicitud de retiro"
    override val billingWithdrawUnavailable = "No hay saldo disponible para retirar"
    override val payoutMethodEtransfer = "eTransfer (Canadá)"
    override val payoutMethodWise = "Transferencia Wise"
    override val payoutDetailsTitle = "Detalles del pago"
    override val payoutEmailLabel = "Correo del destinatario"
    override val payoutWiseNameLabel = "Nombre del titular de la cuenta"
    override val payoutWiseAccountLabel = "Número de cuenta / IBAN"
    override val payoutWiseBankLabel = "Nombre del banco o SWIFT"
    override val payoutWiseRoutingLabel = "Número de ruta"
    override val payoutWiseAccountTypeLabel = "Tipo de cuenta"
    override val payoutAccountTypeChecking = "Corriente"
    override val payoutAccountTypeSavings = "Ahorro"
    override val payoutNoteLabel = "Nota de retiro (opcional)"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) = "$quantity x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) = "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "Ene"; 2 -> "Feb"; 3 -> "Mar"; 4 -> "Abr"; 5 -> "May"; 6 -> "Jun"
        7 -> "Jul"; 8 -> "Ago"; 9 -> "Sep"; 10 -> "Oct"; 11 -> "Nov"; 12 -> "Dic"
        else -> ""
    }
    override val accountDetails = "Detalles de la cuenta"
    override val interfaceLanguage = "Idioma de la interfaz"
    override val profileSavedMessage = "Perfil actualizado"
    override val profileLogoutDescription = "Cerrar sesión de iJoin en este dispositivo."
    override val profileLoadError = "No se pudo cargar el perfil"
    override val logoutError = "Error al cerrar sesión. Por favor, inténtalo de nuevo."
    override val messagesTitle = "Mensajes"
    override val emptyChatList = "Aún no hay conversaciones"
    override val emptyMessages = "Aún no hay mensajes. ¡Inicia la conversación!"
    override val typeMessage = "Mensaje..."
    override val send = "Enviar"
    override val chatSearchPlaceholder = "Buscar usuarios por nombre"
    override val chatSearchNoResults = "No se encontraron usuarios"
    override val chatLoadError = "No se pudieron cargar los mensajes del chat"
    override val chatSendError = "No se pudo enviar el mensaje"
    override val chatOpenError = "No se pudo abrir el chat"
    override val chatStartError = "No se pudo iniciar el chat"
    override val chatSearchError = "No se pueden buscar usuarios en este momento"
    override val paymentTitle = "Pago de reserva"
    override val paymentSubtitle = "Completa el pago de tu reserva"
    override val paymentDescription = "Una vez que el pago sea exitoso, tu reserva se actualizará automáticamente."
    override val paymentPreparing = "Preparando pago con Stripe..."
    override val paymentFetchingTickets = "Obteniendo tus entradas..."
    override val paymentCompletedMessage = "Pago confirmado. Si las entradas no aparecieron automáticamente, actualiza la lista."
    override val paymentStripePopupHint = "Stripe se abre en una ventana emergente. Si no apareció nada o la cerraste, toca \"Reiniciar pago\"."
    override val paymentRetryButton = "Reiniciar pago"
    override val paymentRetryTicketsButton = "Obtener entradas de nuevo"
    override val paymentStartFailed = "Error al iniciar el pago"
    override val paymentTicketContextMissing = "No se pudo determinar la reserva para emitir entradas"
    override val paymentTicketsNotFound = "Entradas no encontradas"
    override val paymentTicketsFetchFailed = "No se pudieron obtener las entradas"
    override val errorUserNotAuthenticated = "Por favor inicia sesión para continuar."
    override val errorAccessDenied = "No tienes permiso para realizar esta acción."
    override val errorForbiddenFollowingList = "Solo puedes ver tu propia lista de seguidos."
    override val errorDataUrlRequired = "Se requieren datos de imagen (dataUrl)."
    override val errorMediaStoreFailed = "Error al almacenar el archivo. Por favor, inténtalo de nuevo."
    override val errorAmountMustBePositive = "El monto debe ser mayor que cero."
    override val errorAmountExceedsBalance = "El monto solicitado excede el saldo disponible."
    override val errorPayoutEmailRequired = "Se requiere correo electrónico para pagos por eTransfer."
    override val errorPayoutWiseInfoRequired = "Se requieren nombre completo, número de ruta y número de cuenta para pagos Wise."
    override val errorPayoutAccountType = "Tipo de cuenta no soportado. Usa cuenta corriente o de ahorro."
    override val errorUnsupportedPayoutMethod = "Método de pago no soportado."
    override val errorEventNotCancelled = "El evento no está cancelado."
    override val errorChatWithSelf = "No puedes iniciar un chat contigo mismo."
    override val errorChatMessageEmpty = "El mensaje no puede estar vacío."
    override val errorEventOrganizerRequired = "Se requieren ID del evento y organizador."
    override val errorEventUnavailable = "El evento ya no está disponible."
    override val errorEventFinished = "El evento ya ha terminado."
    override val errorOrganizerNotProvider = "El organizador no es un proveedor de servicios."
    override val errorServiceProviderInactive = "El proveedor de servicios no está activo."
    override val errorSlotsNotFound = "No se encontraron algunos horarios."
    override val errorSlotsMustSameEvent = "Todos los horarios deben pertenecer al mismo evento."
    override val errorSlotsMustSameOrganizer = "Todos los horarios deben pertenecer al organizador del evento."
    override val errorSlotsUnavailable = "Uno o más horarios no están disponibles."
    override val errorSlotsInPast = "No se pueden reservar horarios en el pasado."
    override val errorSlotsMustBeConsecutive = "Los horarios deben ser consecutivos."
    override val errorEventIdRequired = "Se requiere ID del evento."
    override val errorQuantityAtLeastOne = "La cantidad debe ser al menos 1."
    override val errorPaidReservationRequired = "Este evento requiere una reserva pagada."
    override val errorEventOrganizerInvalid = "El organizador del evento no es válido."
    override val errorEventOrganizerMissing = "No se ha establecido el organizador del evento."
    override val errorOrganizerCannotAccept = "El organizador no puede aceptar reservas."
    override val errorOccurrenceRequired = "Se requiere la fecha del evento."
    override val errorOccurrencePassed = "La fecha seleccionada ya pasó."
    override val errorTicketsNotEnough = "No hay suficientes entradas disponibles para este evento."
    override val errorBookingOtherUser = "La reserva pertenece a otro usuario."
    override val errorBookingNotAwaitingPayment = "La reserva no está esperando pago."
    override val errorBookingCancelled = "La reserva ya está cancelada."
    override val errorBookingNotActive = "La reserva ya no está activa."
    override val errorBookingIssuedTickets = "La reserva ya tiene entradas emitidas."
    override val errorEventRequiresPaymentFlow = "Este evento requiere pago. Completa el pago para finalizar la reserva."
    override val errorReservationQuantityExceeded = "La cantidad solicitada excede la reserva."
    override val errorTicketAlreadyValidated = "La entrada ya fue validada."
    override val errorTicketInactive = "La entrada no está activa."
    override val errorTicketAlreadyCancelled = "La entrada ya está cancelada."
    override val errorTicketUsed = "Las entradas usadas no se pueden cancelar."
    override val errorOccurrencesRequired = "Se requieren las fechas."
    override val errorRequestRequired = "Se requieren datos de solicitud."
    override val errorBookingEventMismatch = "La reserva no corresponde al evento proporcionado."
    override val errorBookingProcessed = "La reserva ya está procesada."
    override val errorOverrideAmountAdminOnly = "Solo los administradores pueden modificar el monto."
    override val errorOverrideAmountPositive = "El monto modificado debe ser positivo."
    override val errorUnableDetermineTicketPrice = "No se pudo determinar el precio de la entrada."
    override val errorEmailAlreadyRegistered = "El correo electrónico ya está registrado."
    override val errorInvalidCredentials = "Correo electrónico o contraseña inválidos."
    override val errorAccountInactive = "La cuenta está inactiva."
    override val errorInvalidRefreshToken = "Token de actualización inválido."
    override val errorAvatarDataUrlRequired = "Los datos del avatar deben proporcionarse como data URL."
    override val errorAvatarMustBeImage = "El avatar debe ser una imagen."
    override val errorAvatarInvalidDataUrl = "El data URL del avatar es inválido."
    override val errorStripeSignatureInvalid = "Firma de Stripe inválida."
    override val errorMediaUnsupportedFormat = "Formato de imagen no soportado."
    override val errorReservationExpired = "La reserva expiró. Por favor, inicia una nueva reserva."
    override val login = "Iniciar sesión"
    override val register = "Registrarse"
    override val continueWithGoogle = "Continuar con Google"
    override val continueWithApple = "Continuar con Apple"
    override val logout = "Cerrar sesión"
    override val password = "Contraseña"
    override val username = "Nombre de usuario"
    override val firstName = "Nombre"
    override val lastName = "Apellido"
    override val confirmPassword = "Confirmar contraseña"
    override val alreadyHaveAccount = "¿Ya tienes una cuenta?"
    override val dontHaveAccount = "¿No tienes una cuenta?"
    override val loginHere = "Inicia sesión aquí"
    override val registerHere = "Regístrate aquí"
    override val welcomeBack = "¡Bienvenido de nuevo!"
    override val createAccount = "Crear cuenta"
    override val loginError = "Error al iniciar sesión. Por favor verifica tus credenciales."
    override val registerError = "Error en el registro. Por favor, inténtalo de nuevo."
    override val passwordsDontMatch = "Las contraseñas no coinciden"
    override val fillAllFields = "Por favor completa todos los campos requeridos"
    override val invalidEmail = "Por favor ingresa una dirección de correo válida"
    override val forgotPassword = "¿Olvidaste tu contraseña?"
    override val passwordResetTitle = "Restablecer contraseña"
    override val passwordResetDescription = "Ingresa tu correo electrónico para recibir instrucciones de restablecimiento."
    override val passwordResetSetNewPassword = "Establecer nueva contraseña"
    override val sendResetLink = "Enviar enlace de restablecimiento"
    override fun passwordResetEmailSent(email: String) = "Si existe una cuenta para $email, enviamos un enlace de restablecimiento."
    override val passwordResetTokenLabel = "Token de restablecimiento"
    override val passwordResetTokenDescription = "Pega el código de tu correo o abre el enlace en este dispositivo."
    override val profileDeletedMessage = "Cuenta eliminada"
    override val deleteAccountTitle = "Eliminar cuenta"
    override val deleteAccountDescription = "Esto desactivará tu cuenta, anonimizará los datos personales y eliminará tus eventos de los resultados de búsqueda."
    override val deleteAccountAction = "Eliminar cuenta"
    override val deleteAccountConfirmMessage = "¿Estás seguro? Por favor, retira cualquier saldo restante mediante una solicitud de pago antes de eliminar tu cuenta."
    override val aiConsentSectionTitle = "Procesamiento de datos de IA"
    override val aiConsentEnabled = "Has dado tu consentimiento para compartir datos con servicios de IA (OpenAI, Google) para funciones opcionales como transcripción y generación de descripciones."
    override val aiConsentDisabled = "El consentimiento para el procesamiento de datos de IA no está activo. Las funciones de IA no están disponibles."
    override val aiConsentWithdrawButton = "Retirar consentimiento"
    override val aiConsentEnableButton = "Habilitar funciones de IA"
    override val aiConsentWithdrawConfirmTitle = "¿Retirar consentimiento de IA?"
    override val aiConsentWithdrawConfirmMessage = "Las funciones de IA (transcripción, generación de descripciones, páginas de destino) dejarán de estar disponibles. Puedes volver a habilitarlas en cualquier momento."
    override val aiConsentWithdrawnSuccess = "Se retiró el consentimiento para el procesamiento de datos de IA"
    override val aiConsentEnabledSuccess = "Se otorgó el consentimiento para el procesamiento de datos de IA"
    override val errorAccountDeleted = "La cuenta ha sido eliminada."
    override val errorAccountBalanceNotZero = "Por favor, retira el saldo restante antes de eliminar tu cuenta."
    override val newPassword = "Nueva contraseña"
    override val resetPasswordAction = "Actualizar contraseña"
    override val passwordResetSuccess = "¡Contraseña actualizada! Puedes iniciar sesión con la nueva contraseña."
    override val backToLogin = "Volver al inicio de sesión"
    override val invalidPhone = "Por favor ingresa un número de teléfono válido"
    override val provideAnyContact = "Ingresa teléfono o correo electrónico"
    override val checkContacts = "Por favor verifica el formato de los contactos"
    override val contactSubmitting = "Guardando..."
    override val contactSubmitted = "Solicitud enviada"
    override val book = "Reservar"
    override val bookFree = "Reservar gratis"
    override val bookingSuccess = "¡Reservado con éxito!"
    override val bookingFailed = "Error en la reserva"
    override fun bookForPrice(price: String) = "Reservar por $price"
    override val prev = "Anterior"
    override val showAll = "Mostrar todo"
    override val collapse = "Colapsar"
    override val missingTitle = "Ingresa el título del evento"
    override val missingDescription = "Ingresa la descripción del evento"
    override val missingScheduleType = "Selecciona el tipo de horario"
    override val missingDate = "Selecciona la fecha del evento"
    override val missingTime = "Selecciona la hora del evento"
    override val missingWeeklyDays = "Selecciona uno o más días"
    override val missingWeeklyTime = "Selecciona la hora para el evento semanal"
    override val missingSlotDays = "Selecciona los días de los horarios"
    override val missingSlotStart = "Selecciona la hora de inicio del horario"
    override val missingSlotEnd = "Selecciona la hora de fin del horario"
    override val missingLocation = "Por favor especifica la ubicación del evento"
    override val optional = "Opcional"
    override val bookingsTitle = "Reservas"
    override val unconfirmedRequestsTitle = "Solicitudes sin confirmar"
    override val detailsButton = "Detalles"
    override val hideDetailsBooking = "Ocultar"
    override val noBookings = "Aún no hay reservas"
    override val noUnconfirmedRequests = "No hay solicitudes sin confirmar"
    override val ticketInfoLabel = "Entrada"
    override val contactInfoLabel = "Información de contacto"
    override val paymentInfoLabel = "Pago"
    override val loadingPayment = "Cargando..."
    override val clientLabel = "Cliente"
    override val paymentAmount = "Monto"
    override val paymentStatus = "Estado"
    override val paymentDate = "Fecha"
    override val appStoreBannerTitle = "Obtén la app"
    override val appStoreBannerMessage = "Descarga nuestra app para la mejor experiencia"
    override val downloadOnAppStore = "Descargar en App Store"
    override val getItOnGooglePlay = "Disponible en Google Play"
    override val downloadAppLinks = "Descarga nuestra app"
    override val updateAvailable = "Actualización disponible"
    override val updateRequired = "Actualización requerida"
    override val updateAvailableMessage = "Hay una nueva versión de iJoin disponible. Actualiza ahora para obtener las últimas funciones y mejoras."
    override val updateRequiredMessage = "Por favor actualiza iJoin para continuar usando la app. Esta versión ya no es compatible."
    override val updateNow = "Actualizar ahora"
    override val updateLater = "Más tarde"
    override val newVersion = "Nueva versión"
    override val currentVersion = "Versión actual"
    override val whatsNew = "Novedades"
    override val landingModeClassic = "Clásico"
    override val landingModeAi = "Página de aterrizaje IA"
    override val landingModeTitle = "Tipo de página de aterrizaje"
    override val landingDescriptionLabel = "Descripción de la página"
    override val landingDescriptionPlaceholder = "Describe tu evento para que la IA genere una hermosa página de aterrizaje..."
    override val recordVoice = "Grabar voz"
    override val stopRecording = "Detener grabación"
    override val transcribing = "Transcribiendo..."
    override val recordingTooShort = "La grabación es muy corta (mínimo 3 segundos)"
    override val recordingTooLong = "La grabación es muy larga (máximo 5 minutos)"
    override val microphoneAccessDenied = "Acceso al micrófono denegado"
    override fun recordingDuration(seconds: Int) = "${seconds}s"
    override val enableLandingPageLabel = "Usar página de aterrizaje"
    override val enableLandingPageDescription = ""
    override val termsOfService = "Términos de servicio"
    override val privacyPolicy = "Política de privacidad"
    override val refundPolicy = "Política de reembolso y cancelación"
    override val organizerTerms = "Términos para organizadores"
    override val aiDataConsent = "Consentimiento para el procesamiento de datos con IA"
    override val aiConsentTitle = "Las funciones de IA usan servicios de terceros"
    override val aiConsentDescription = "Algunas funciones de esta aplicación utilizan servicios de inteligencia artificial proporcionados por OpenAI y Google. Cuando usas estas funciones, cierto contenido que proporcionas se envía a estos servicios para su procesamiento."
    override val aiConsentDataSent = "Datos que pueden enviarse:"
    override val aiConsentDataSentAudio = "Grabaciones de audio (para transcripción)"
    override val aiConsentDataSentDescription = "Descripciones de eventos (para mejorar el texto)"
    override val aiConsentDataSentLanding = "Detalles de la página de destino (para generar contenido)"
    override val aiConsentProviders = "Los datos son procesados por OpenAI (OpenAI, L.L.C.) y Google (Google LLC). Tus datos personales (nombre, correo) no se envían a menos que formen parte del contenido que envías. Consulta el documento completo para más detalles."
    override val aiConsentOptional = "Las funciones de IA son opcionales. Puedes usar la aplicación sin ellas."
    override val aiConsentAccept = "Acepto"
    override val aiConsentDecline = "Ahora no"
    override val iAgreeToThe = "Acepto lo siguiente:"
    override val iAgreeToTerms = "Acepto los Términos de servicio, Política de privacidad y Política de reembolso"
    override val iAgreeToOrganizerTerms = "Acepto los Términos para organizadores"
    override val pleaseAcceptTerms = "Por favor acepta los términos para continuar"
    override val pleaseAcceptOrganizerTerms = "Por favor acepta los Términos para organizadores para publicar eventos"
    override val viewDocument = "Ver"
    override val legalDocumentLoading = "Cargando documento..."
    override val legalDocumentLoadError = "Error al cargar el documento"
    override val newUserGoogleNote = "Si eres nuevo, por favor acepta los términos antes de iniciar sesión con Google:"
    override val legalDocumentsUpdated = "Términos actualizados"
    override val legalDocumentsUpdatedDescription = "Hemos actualizado nuestros términos. Por favor revisa y acepta los documentos actualizados para continuar usando la app."
    override val iAcceptUpdatedTerms = "Acepto los términos actualizados"
    override val continueButton = "Continuar"
    override val deleteEventFailed = "No se pudo eliminar el evento."
    override val mediaDesktopLabel = "Para escritorio (panorámico)"
    override val mediaMobileLabel = "Para móvil (cuadrado)"
    override val slotLoadFailed = "No se pudieron cargar los horarios"
    override val slotBookingFailed = "No se pudieron reservar los horarios"
    override val ticketIssuanceFailed = "No se pudieron emitir los boletos"
    override val unpublishedBookingNotice = "La reserva estará disponible cuando este evento se publique."
    override val paymentStripeOverlayTitle = "Pago con Stripe"
    override val paymentStripeOverlayDescription = "Introduce los datos de tu tarjeta para finalizar la reserva."
    override val paymentStripeOverlayPayButton = "Pagar ahora"
    override val paymentStripeOverlayPayButtonLoading = "Procesando..."
    override val paymentStripeOverlayCancelButton = "Cancelar"
    override val paymentStripeOverlayOpenError = "No se pudo abrir el pago de Stripe."
    override val paymentStripeOverlayCancelMessage = "Pago cancelado"
    override val paymentStripeOverlayInitError = "No se pudo inicializar Stripe."
    override val paymentStripeOverlayPaymentFailed = "El pago falló"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "Estado inesperado: "
    override val paymentStripeOverlayProcessingFailed = "No se pudo procesar el pago"
    override val appStoreUnavailableMessage = "Lo sentimos, la aplicación se está publicando en la tienda y estará disponible pronto."

}
